module.exports = __webpack_public_path__ + "static/media/elcorteingles@2x.ed1c9d27.jpg";